import { useContext } from 'react';

import { Checkbox, Typography } from '@mui/material';
import { wellzTheme as muiWellzTheme } from '@wellz-theme/mui';
import { infoSessionCancelledAtom } from 'atoms/inviteSession';
import { useAtomValue } from 'jotai';
import { FormattedMessage, useIntl } from 'react-intl';
import { wellzTheme } from 'theme';
import { formatDate, formatHour } from 'utils/helpers';

import { DrawerInviteScheduleContext } from 'components/DrawerInviteSchedule/context/DrawerInviteScheduleContext';

import * as S from '../../styles';
import * as Styles from './styles';

const ConfirmInviteRescheduled: React.FC = () => {
  const intl = useIntl();
  const infoSessionCancelled = useAtomValue(infoSessionCancelledAtom);
  const { date, hour, isChecked, setIsChecked } = useContext(
    DrawerInviteScheduleContext,
  );

  if (!infoSessionCancelled || !date || !hour) {
    return null;
  }

  return (
    <S.Body className="createInvite">
      <div>
        <Typography
          variant="h5"
          style={{ marginBottom: muiWellzTheme.spacing(2.5) }}
        >
          <FormattedMessage id="CPPLATFORM.CPINVITECONFIRM.TITLE" />
        </Typography>

        <Typography
          variant="body1"
          style={{
            marginBottom: muiWellzTheme.spacing(3),
            color: muiWellzTheme.palette.text.secondary,
          }}
        >
          <FormattedMessage
            id="CPPLATAFORM.CPNEWTIMECONFIRM.SUBTITLE"
            values={{
              PatientName: infoSessionCancelled.fullName,
              b: (chunks: string) => (
                <S.TextMedium color={muiWellzTheme.palette.text.secondary}>
                  {chunks}
                </S.TextMedium>
              ),
            }}
          />
        </Typography>

        <Styles.ContainerDates>
          <div>
            <Styles.ContainerRow>
              <Styles.ContainerIcon background={wellzTheme.colors.deepRed}>
                <Styles.EventBusyIcon />
              </Styles.ContainerIcon>

              <div>
                <Typography
                  variant="subtitle2"
                  style={{ marginBottom: muiWellzTheme.spacing(0.5) }}
                >
                  <FormattedMessage id="CPPLATAFORM.CPNEWTIMECONFIRM.DETAILSSESSIONCANCELLED" />
                </Typography>

                <S.ContainerRow>
                  <S.CalendarIcon />
                  <Typography
                    variant="body1"
                    style={{ marginRight: muiWellzTheme.spacing(4) }}
                  >
                    {formatDate(infoSessionCancelled.date.toString(), {
                      locale: intl.locale,
                    })}
                  </Typography>
                  <S.HourIcon />
                  <Typography variant="body1">
                    {formatHour(infoSessionCancelled.date.toString(), {
                      locale: intl.locale,
                    })}
                  </Typography>
                </S.ContainerRow>
              </div>
            </Styles.ContainerRow>
          </div>

          <Styles.ContainerDivider>
            <Styles.Divider />
          </Styles.ContainerDivider>

          <div>
            <Styles.ContainerRow>
              <Styles.ContainerIcon background={wellzTheme.colors.primary}>
                <Styles.CalendarIcon />
              </Styles.ContainerIcon>

              <div>
                <Typography
                  variant="subtitle2"
                  style={{ marginBottom: muiWellzTheme.spacing(0.5) }}
                >
                  <FormattedMessage id="CPPLATAFORM.CPNEWTIMECONFIRM.DETAILNEWSESSION" />
                </Typography>

                <S.ContainerRow>
                  <S.CalendarIcon />
                  <Typography
                    variant="body1"
                    style={{ marginRight: muiWellzTheme.spacing(4) }}
                  >
                    {formatDate(date, { locale: intl.locale })}
                  </Typography>
                  <S.HourIcon />
                  <Typography variant="body1">
                    {formatHour(hour, { locale: intl.locale })}
                  </Typography>
                </S.ContainerRow>
              </div>
            </Styles.ContainerRow>
          </div>
        </Styles.ContainerDates>

        <S.ContainerInvite>
          <Typography
            variant="caption"
            style={{ marginBottom: muiWellzTheme.spacing(2) }}
          >
            <FormattedMessage id="CPPLATFORM.CPINVITECONFIRM.SUBTITLEMESSAGE" />
          </Typography>

          <S.ContainerWhite>
            <Typography
              variant="body2"
              style={{
                color: wellzTheme.colors.text.disabled,
              }}
            >
              <FormattedMessage
                id="CPPLATAFORM.CPNEWTIMECONFIRM.MESSAGEFRONT"
                values={{
                  patientName: infoSessionCancelled.fullName,
                  date: formatDate(infoSessionCancelled.date, {
                    locale: intl.locale,
                  }),
                  b: (chunks: string) => <S.TextMedium>{chunks}</S.TextMedium>,
                }}
              />
            </Typography>
          </S.ContainerWhite>
        </S.ContainerInvite>
      </div>

      <Styles.CheckboxContainer>
        <Checkbox value={isChecked} onChange={() => setIsChecked(!isChecked)} />
        <Typography variant="body2">
          <FormattedMessage
            id="CPPLATAFORM.CPNEWTIMECONFIRM.WARNINGMESSAGE"
            values={{
              b: (chunks: string) => <S.TextMedium>{chunks}</S.TextMedium>,
            }}
          />
        </Typography>
      </Styles.CheckboxContainer>
    </S.Body>
  );
};

export default ConfirmInviteRescheduled;
